import BlockCrissCross from './crissCross'

export default BlockCrissCross
